var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1719107551806,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 21128,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 972.8C260.266667 972.8 51.2 763.733333 51.2 512S260.266667 51.2 512 51.2 972.8 260.266667 972.8 512 763.733333 972.8 512 972.8z m0-853.333333c-217.6 0-392.533333 174.933333-392.533333 392.533333s174.933333 392.533333 392.533333 392.533333 392.533333-174.933333 392.533333-392.533333-174.933333-392.533333-392.533333-392.533333z",
    "p-id": 21129,
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M640 716.8c-8.533333 0-21.333333-4.266667-25.6-12.8l-256-341.333333c-8.533333-17.066667-8.533333-38.4 4.266667-46.933334s34.133333-8.533333 46.933333 4.266667l256 341.333333c8.533333 12.8 8.533333 34.133333-4.266667 42.666667-8.533333 8.533333-12.8 12.8-21.333333 12.8z",
    "p-id": 21130,
    fill: "#333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M384 716.8c-8.533333 0-12.8 0-17.066667-8.533333-12.8-8.533333-17.066667-29.866667-4.266666-42.666667l256-341.333333c8.533333-12.8 29.866667-17.066667 42.666666-4.266667 12.8 8.533333 17.066667 29.866667 4.266667 46.933333l-256 341.333334c-4.266667 0-17.066667 8.533333-25.6 8.533333z",
    "p-id": 21131,
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.740c14f1755c5e952d3c6e2c0966ba58.svg";
export { ForwardRef as ReactComponent };